import { getEffectiveUserStatus } from '@modules/user/utils/getEffectiveUserStatus';
import { ChatChannelType, IChatConversation } from 'src/@types/chat';
import { PATH_DASHBOARD } from 'src/Router/paths';
import BadgeStatus from 'src/components/badge-status';
import { CustomAvatar } from 'src/components/custom-avatar';
import { NavItem } from 'src/features/Navbar/NavItem';
import { useWorkspaceParticipantsUsers } from 'src/hooks/useWorkspace';
import { ChatNavItemP2P } from './ChatNavItemP2P';
import { ChatNavItemText } from './ChatNavItemText';
import { ChatNavItemVoice } from './chatNavItemVoice';

type Props = {
  conversation: IChatConversation;
};

export function ChatNavItem({ conversation }: Props) {
  const [participant] = useWorkspaceParticipantsUsers(
    conversation.participants,
  );

  if (conversation.type === ChatChannelType.TEXT && !conversation.p2p)
    return <ChatNavItemText conversation={conversation} />;

  if (conversation.type === ChatChannelType.VOICE) {
    return <ChatNavItemVoice conversation={conversation} />;
  }

  if (conversation.p2p) {
    return ChatNavItemP2P({ conversation });
  }

  return (
    <NavItem
      path={PATH_DASHBOARD.chat.view(conversation._id)}
      icon={
        <CustomAvatar
          key={participant._id}
          alt={participant.name}
          src={participant.picture}
          BadgeProps={{
            badgeContent: (
              <BadgeStatus status={getEffectiveUserStatus(participant)} />
            ),
          }}
          sx={{ width: 48, height: 48 }}
        />
      }
      depth={1}
      highlight={!!conversation.unreadMessages?.length}
    >
      {conversation.name}
    </NavItem>
  );
}
